import { Buffer } from 'buffer';

export const fetchPreAuthToken = async () => {
    const encode = (str: string): string =>
        Buffer.from(str, 'binary').toString('base64');

    try {
        const clientID = process.env.REACT_APP_PREAUTH_CLIENT_ID!
        const clientPassword = process.env.REACT_APP_PREAUTH_CLIENT_SECRET!
        const url = `${process.env.REACT_APP_COGNITO_DOMAIN!}/oauth2/token`
        const scope = `${process.env.REACT_APP_STAGE}-resource-server-id/PreAuthScope`
        let params = new URLSearchParams();
        params.append('grant_type', 'client_credentials');
        params.append('client_id', clientID);
        params.append('scope', scope);
        const resp = await fetch(url, {
            method: 'POST',
            body: params,
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/x-www-form-urlencoded',
                'Authorization': `Basic ${encode(`${clientID}:${clientPassword}`)}`
            },
        })
        return await resp.json();
    } catch (err) {
        console.error(`Error getting pre auth token ${err}`);
    }
}

